export enum MessageType {
  Success = 'success',
  Error = 'error',
  Danger = 'danger',
  Info = 'info'
}